'use strict';

import React from 'react';

import { useEffect, useState, useRef, useContext, useMemo } from 'react';

import { Button, Form, Row, Col, Table, Card, InputGroup } from 'react-bootstrap';

import { Formik } from 'formik';
import * as yup from 'yup';

import useRequest from '../helper/useRequest';

import { toast } from 'react-toastify';
import AppContext from '../AppContext';
import Separator from '../helper/Separator';
import Alert from '../helper/Alert';

import Select from 'react-select';

import MandatoryFieldNotice from '../helper/MandatoryFieldNotice';

import {
    email,
    emailRepeat,
    password,
    passwordRepeat,
    username,
    firstName,
    lastName,
    organisationName,
    phoneNo,
    street,
    houseNo,
    city,
    postCode,
    court,
    compRegNo,
    chamberMembership,
    newsletterOptIn,
    additionToAddress,
    conditionUse
} from '../helper/Schema';


const schema = yup.object().shape({
    OrganisationName: organisationName,
    Email: email,
    Emailrepeat: emailRepeat,
    Password: password,
    Passwordrepeat: passwordRepeat,
    Username: username,
    FirstName: firstName,
    LastName: lastName,
    PhoneNo: phoneNo,
    Street: street,
    HouseNo: houseNo,
    AdditionToAddress: additionToAddress,
    City: city,
    PostCode: postCode,
    Court: yup.string().when("Radio", {
        is: (Radio) => Radio === "1",
        then: () => court,
    }),
    CompRegNo: yup.string().when("Radio", {
        is: (Radio) => Radio === "1",
        then: () => compRegNo,
    }),
    ChamberMembership: yup.string().when("Radio", {
        is: (Radio) => Radio === "2",
        then: () => chamberMembership,
    }),
    IsAlternativeBilling: yup.boolean(),
    BillingStreet: yup.string().when("IsAlternativeBilling", {
        is: (IsAlternativeBilling) => IsAlternativeBilling === true,
        then: () => street,
    }),
    BillingHouseNo: yup.string().when("IsAlternativeBilling", {
        is: (IsAlternativeBilling) => IsAlternativeBilling === true,
        then: () => houseNo,
    }),
    BillingAdditionToAddress: yup.string().when("IsAlternativeBilling", {
        is: (IsAlternativeBilling) => IsAlternativeBilling === true,
        then: () => additionToAddress,
    }),
    BillingCity: yup.string().when("IsAlternativeBilling", {
        is: (IsAlternativeBilling) => IsAlternativeBilling === true,
        then: () => city,
    }),
    BillingPostCode: yup.string().when("IsAlternativeBilling", {
        is: (IsAlternativeBilling) => IsAlternativeBilling === true,
        then: () => postCode, 
    }),
    BillingEmail: yup.string().when("IsAlternativeBilling", {
        is: (IsAlternativeBilling) => IsAlternativeBilling === true,
        then: () => email,
    }),
    
});

const schema2 = yup.object().shape({
    NewsletteroptIn: newsletterOptIn,
    ConditionOfUse: conditionUse,
});

function Register() {
    const { request } = useRequest();

    const { Salutations, getSalutation } = useContext(AppContext);

    const [categories, setCategories] = useState([]);
    const [abos, setAbos] = useState([]);
    //const [companyRegisterFile, setCompanyRegisterFile] = useState(null);
    const [businessLicenseFile, setBusinessLicenseFile] = useState(null);
    const [step, setStep] = useState(0);
    const [passwordShown, setPasswordShown] = useState(false);

    const [presetNames, setPresetNames] = useState(null);
    const [presetTerms, setPresetTerms] = useState(null);
    const [presetDates, setPresetDates] = useState(null);
    const [presetUsers, setPresetUsers] = useState(null);
    const [presetContacts, setPresetContacts] = useState(null);
    const [presetPerimeter, setPresetPerimeter] = useState(null);
    const [presetPrices, setPresetPrices] = useState(null);
    const [couponCode, setCouponCode] = useState("");
    const [couponStatus, setCouponStatus] = useState("waiting");
    const [activeCoupon, setActiveCoupon] = useState(null);
    const [reduction, setReduction] = useState(0);


    const [errorMessage, setErrorMessage] = useState("");

    const formRef = useRef(null);
    const formRef2 = useRef(null);

    const [data, setData] = useState({
        OrganisationName: '',
        Email: '',
        Emailrepeat: '',
        Username: '',
        Password: '',
        Passwordrepeat: '',
        SalutationID: {value: 1, label: "Herr"},
        Title: '',
        FirstName: '',
        LastName: '',
        PhoneNo: '',
        Street: '',
        HouseNo: '',
        AdditionToAddress: '',
        City: '',
        PostCode: '',
        Court: '',
        CompRegNo: '',
        Category: [],
        BillingStreet: '',
        BillingHouseNo: '',
        BillingAdditionToAddress: '',
        BillingCity: '',
        BillingPostCode: '',
        BillingEmail: '',
        IsBusiness: true,
        IsAlternativeBilling: false,
        ChamberMembership: '',
        Radio: "1",
        IsInstitution: false,
        NewsletterOptIn: false,
        ConditionOfUse: false
    });

    const handleSchoolData = async (values) => {
        values.businessLicenseFile = businessLicenseFile;
       
        setErrorMessage("");
        if (values.Radio === "3" && businessLicenseFile === null) {
            setErrorMessage("Bitte Gewerbeschein auswählen.");
            const element = document.getElementById("radio-1");
            element.scrollIntoView();
            return;
        }
        if (values.Radio === "4") {
            values.IsInstitution = true;
        }

        setData(data => { return { ...data, ...values } });
        setStep(1);
        document.getElementById("content").scrollIntoView();
    };

    const handleSubmitBusiness = async (values) => {        
        
        const formData = { ...data, ...values, couponCode: activeCoupon };

        formData.Category = formData.Category.map(m => m.value);
        formData.SalutationID = formData.SalutationID.value;        

        const result = await request("/Register/RegisterBusinessUser", formData);
        const json = result.data;

        if (json.r == 1) {
            window.location.replace("/Register/Finish"); 
        }
        else {
            toast.error(json.message);
            if (json.couponExpired) {
                setStep(0);
                setActiveCoupon("");
                setCouponStatus("error");
            }
        }
    };  

    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };

    const ErrorMessage = function (errors) {
        var errorList = [];
        for (var key in errors) {
            errorList.push(errors[key]);
        }
        if (errorList.length == 0) return "";
        return <div>Hat Fehler</div>;
    };

    const handleBusinessLicenseFileupload = function (e) {
        var fileNode = document.createElement("input");
        fileNode.type = "file";
        fileNode.addEventListener("change", function (e2) {
            setBusinessLicenseFile(e2.currentTarget.files[0]);
        });
        fileNode.click();
    }

    const sortedCategories = useMemo(() => categories.sort((a, b) => {
        const nameA = a.label.toUpperCase();
        const nameB = b.label.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
    }), [categories]);

    const setAbo = (index) => {
        setData(data => { return { ...data, abo: index } });
        setStep(2);
        document.getElementById("content").scrollIntoView();
    }

    const back = () => {
        setStep(step => Math.max(0, Math.min(step - 1, 4)));
        document.getElementById("content").scrollIntoView();
    }

    useEffect(() => {
        const getCategories = async () => {
            try {
                let result = await request("/Register/GetBusinessCategories");
                let json = result.data;
                if (json.r != 1) {
                    if (json.message) {
                        toast.error(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten.");
                    }
                }
                else {
                    let arr = json.categories.map((ca) => { return { value: ca.CategoryID, label: ca.Description }; });
                    setCategories(arr);
                    setAbos(json.abos);
                }
            }
            catch {
                toast.error("Fehler beim Laden");
            }
        };
        getCategories();
    }, []);

    useEffect(() => {
        var names = [];
        for (var i = 0; i < abos.length; i++) {
            names.push(<th className="level-1 text-center border-top-0">{abos[i].Name}</th>);
        }
        setPresetNames(names);
    }, [abos]);

    const salutationOptions = Salutations.map((a) => { return { value: a.SalutationID, label: a.Description }; });

    const couponChanged = async (e) => {
        try {
            const couponCode = e.currentTarget.value;

            if (!couponCode) {
                return;
            }

            setCouponStatus("loading");
            let result = await request("/Register/CheckCoupon", { code: couponCode });
            let json = result.data;
            if (json.r != 1) {
                setCouponStatus("error");
            }
            else {
                setCouponStatus("success");
                setActiveCoupon(couponCode);
                setReduction(json.reduction);
            }
            
        }
        catch (ex) {
            setCouponStatus("error");
            toast.error("Falscher Gutscheincode.");
        }
    };

    

    // dateneingabe

    if (step == 0) {
        return (
            <Formik
                innerRef={(f) => formRef.current = f}
                validationSchema={schema}
                validateOnChange={true}
                validateOnBlur={true}
                onSubmit={(values) => {
                    handleSchoolData(values);
                }}
                initialValues={data}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                }) => (
                    <Form noValidate onSubmit={handleSubmit} className="mt-3">

                        <Separator text="Unternehmensdaten" />
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="OrganisationName">
                                    <Form.Label column className="required" sm={6}>Unternehmensbezeichnung</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.OrganisationName && touched.OrganisationName} placeholder="" name="OrganisationName" value={values.OrganisationName} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.OrganisationName}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="Category">
                                    <Form.Label column sm={6}>Betriebskategorie</Form.Label>
                                    <Col sm={6}>
                                        <Select isMulti closeMenuOnSelect={false} name="Category" options={sortedCategories} classNamePrefix="bv-select" className="bv-select" placeholder="Bitte auswählen" defaultValue={values.Category || []} onChange={
                                            (values) => {
                                                // let vals = values.map((v) => v.value);
                                                formRef.current.setFieldValue("Category", values);
                                            }
                                        } />
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="Street">
                                    <Form.Label column className="required" sm={6}>Straße</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.Street && touched.Street} placeholder="" name="Street" value={values.Street} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Street}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="HouseNo">
                                    <Form.Label column className="required" sm={6}>Hausnummer</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.HouseNo && touched.HouseNo} placeholder="" name="HouseNo" value={values.HouseNo} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.HouseNo}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="AdditionToAddress">
                                    <Form.Label column sm={6}>Adresszusatz</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.AdditionToAddress && touched.AdditionToAddress} placeholder="" name="AdditionToAddress" value={values.AdditionToAddress} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.AdditionToAddress}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="PostCode">
                                    <Form.Label column className="required" sm={6}>Postleitzahl</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.PostCode && touched.PostCode} placeholder="" name="PostCode" value={values.PostCode} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.PostCode}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="City">
                                    <Form.Label column className="required" sm={6}>Stadt</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.City && touched.City} placeholder="" name="City" value={values.City} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.City}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>

                        </Row>
                        <div className="mb-3">
                            <Form.Check
                                type="radio"
                                id="radio-1"
                                name="Radio"
                                label="Handelsregisternummer & Amtsgericht"
                                value="1"
                                checked={values.Radio === "1"}
                                onChange={handleChange}
                            />
                            <Form.Check
                                type="radio"
                                id="radio-2"
                                name="Radio"
                                label="Kammerzugehörigkeit"
                                value="2"
                                checked={values.Radio === "2"}
                                onChange={handleChange}
                            />
                            <Form.Check
                                type="radio"
                                id="radio-3"
                                name="Radio"
                                label="Gewerbeschein"
                                value="3"
                                checked={values.Radio === "3"}
                                onChange={handleChange}
                            />
                            <Form.Check
                                type="radio"
                                id="radio-4"
                                name="Radio"
                                label="Institution des öffentlichen Rechts"
                                value="4"
                                checked={values.Radio === "4"}
                                onChange={handleChange}
                            />
                        </div>
                        {values.Radio === '1' && (
                            <Row className="mb-2">
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="CompRegNo">
                                        <Form.Label column className="required" sm={6}>Handelsregisternummer</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control isInvalid={errors.CompRegNo && touched.CompRegNo} placeholder="" name="CompRegNo" value={values.CompRegNo} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.CompRegNo}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="Court">
                                        <Form.Label column className="required" sm={6}>Amtsgericht</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control isInvalid={errors.Court && touched.Court} placeholder="" name="Court" value={values.Court} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.Court}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                {/*<Col xs={12} lg={3}>*/}
                                {/*    {!companyRegisterFile && (*/}
                                {/*        <Button variant="secondary" type="button" className="me-2" onClick={handleFileupload}>*/}
                                {/*            <i className="fa-solid fa-upload me-2"></i>Unternehmensregisterauszug hochladen*/}
                                {/*        </Button>*/}
                                {/*    )}*/}
                                {/*    {companyRegisterFile && (*/}
                                {/*        <Button variant="secondary" type="button" className="me-2" onClick={handleFileupload}>*/}
                                {/*            <i className="fa-solid fa-upload me-2"></i> {companyRegisterFile.name}*/}
                                {/*        </Button>*/}
                                {/*    )}*/}
                                {/*</Col>*/}
                            </Row>
                        )}
                        {values.Radio === '2' && (
                            <Row className="mb-2">
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="ChamberMembership">
                                        <Form.Label column className="required" sm={6}>Kammerzugehörigkeit</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control isInvalid={errors.ChamberMembership && touched.ChamberMembership} placeholder="" name="ChamberMembership" value={values.ChamberMembership} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.ChamberMembership}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                        )}
                        {values.Radio === '3' && (
                            <Row className="mb-2">
                                <Col xs={12} lg={4}>
                                    {!businessLicenseFile && (
                                        <Button variant="secondary" id="businessLicenseBtn" type="button" className="me-2" onClick={handleBusinessLicenseFileupload}>
                                            <i className="fa-solid fa-upload me-2"></i>Gewerbeschein hochladen
                                        </Button>
                                    )}
                                    {businessLicenseFile && (
                                        <Button variant="secondary" type="button" className="me-2" onClick={handleBusinessLicenseFileupload}>
                                            <i className="fa-solid fa-upload me-2"></i> {businessLicenseFile.name}
                                        </Button>
                                    )}
                                    <div className="text-danger">{errorMessage}</div>
                                </Col>

                            </Row>
                        )}
                        {values.Radio === '4' && (<></>)}
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group className="mb-3" controlId="IsAlternativeBilling">
                                    <Form.Check type="checkbox" label="Abweichende Rechnungsadresse" value={values.IsAlternativeBilling} onChange={handleChange} />
                                </Form.Group>
                            </Col>
                        </Row>
                        {values.IsAlternativeBilling && (
                            <>
                                <Separator text="Abweichende Rechnungsadresse" />
                                <Row>
                                    <Col xs={12} lg={6}>
                                        <Form.Group as={Row} className="mb-3" controlId="BillingEmail">
                                            <Form.Label column className="required" sm={6}>E-Mail-Adresse</Form.Label>
                                            <Col sm={6}>
                                                <Form.Control isInvalid={errors.BillingEmail && touched.BillingEmail} placeholder="" name="BillingEmail" value={values.BillingEmail} onBlur={handleBlur} onChange={handleChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.BillingEmail}
                                                </Form.Control.Feedback>
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} lg={6}>
                                        <Form.Group as={Row} className="mb-3" controlId="BillingStreet">
                                            <Form.Label column className="required" sm={6}>Straße</Form.Label>
                                            <Col sm={6}>
                                                <Form.Control isInvalid={errors.BillingStreet && touched.BillingStreet} placeholder="" name="BillingStreet" value={values.BillingStreet} onBlur={handleBlur} onChange={handleChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.BillingStreet}
                                                </Form.Control.Feedback>
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} lg={6}>
                                        <Form.Group as={Row} className="mb-3" controlId="BillingHouseNo">
                                            <Form.Label column className="required" sm={6}>Hausnummer</Form.Label>
                                            <Col sm={6}>
                                                <Form.Control isInvalid={errors.BillingHouseNo && touched.BillingHouseNo} placeholder="" name="BillingHouseNo" value={values.BillingHouseNo} onBlur={handleBlur} onChange={handleChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.BillingHouseNo}
                                                </Form.Control.Feedback>
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} lg={6}>
                                        <Form.Group as={Row} className="mb-3" controlId="BillingAdditionToAddress">
                                            <Form.Label column sm={6}>Adresszusatz</Form.Label>
                                            <Col sm={6}>
                                                <Form.Control isInvalid={errors.BillingAdditionToAddress && touched.BillingAdditionToAddress} placeholder="" name="BillingAdditionToAddress" value={values.BillingAdditionToAddress} onBlur={handleBlur} onChange={handleChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.BillingAdditionToAddress}
                                                </Form.Control.Feedback>
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} lg={6}>
                                        <Form.Group as={Row} className="mb-3" controlId="BillingPostCode">
                                            <Form.Label column className="required" sm={6}>Postleitzahl</Form.Label>
                                            <Col sm={6}>
                                                <Form.Control isInvalid={errors.BillingPostCode && touched.BillingPostCode} placeholder="" name="BillingPostCode" value={values.BillingPostCode} onBlur={handleBlur} onChange={handleChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.BillingPostCode}
                                                </Form.Control.Feedback>
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} lg={6}>
                                        <Form.Group as={Row} className="mb-3" controlId="BillingCity">
                                            <Form.Label column className="required" sm={6}>Stadt</Form.Label>
                                            <Col sm={6}>
                                                <Form.Control isInvalid={errors.BillingCity && touched.BillingCity} placeholder="" name="BillingCity" value={values.BillingCity} onBlur={handleBlur} onChange={handleChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.BillingCity}
                                                </Form.Control.Feedback>
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </>
                        )}
                        <Separator text="Benutzerdaten" />
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="SalutationID" name="SalutationID" onBlur={handleBlur} onChange={handleChange}>
                                    <Form.Label column className="required" sm={6}>Anrede</Form.Label>
                                    <Col sm={6}>
                                        <Select defaultValue={salutationOptions[0]} name="SalutationID" options={salutationOptions} defaultValue={values.SalutationID} classNamePrefix="bv-select" className="bv-select" placeholder="Bitte auswählen" onChange={
                                            (value) => {
                                                formRef.current.setFieldValue("SalutationID", value);
                                            }
                                        } />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="Title">
                                    <Form.Label column sm={6}>Titel</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.Title && touched.Title} placeholder="" name="Title" value={values.Title} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Title}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="FirstName">
                                    <Form.Label column className="required" sm={6}>Vorname</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.FirstName && touched.FirstName} placeholder="" name="FirstName" value={values.FirstName} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.FirstName}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="LastName">
                                    <Form.Label column className="required" sm={6}>Nachname</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.LastName && touched.LastName} placeholder="" name="LastName" value={values.LastName} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.LastName}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="PhoneNo">
                                    <Form.Label column className="required" sm={6}>Telefonnummer</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.PhoneNo && touched.PhoneNo} placeholder="" name="PhoneNo" value={values.PhoneNo} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.PhoneNo}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>

                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="EmailB">
                                    <Form.Label column className="required" sm={6}>E-Mail-Adresse</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.Email && touched.Email} placeholder="" name="Email" value={values.Email} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Email}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="Emailrepeat" autoComplete="off">
                                    <Form.Label column className="required" sm={6}>E-Mail wiederholen</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.Emailrepeat && touched.Emailrepeat} placeholder="" name="Emailrepeat" value={values.Emailrepeat} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Emailrepeat}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="Username">
                                    <Form.Label column className="required" sm={6}>Benutzername</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.Username && touched.Username} placeholder="" name="Username" value={values.Username} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Username}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="Password" autoComplete="off">
                                    <Form.Label column className="required" sm={6}>Passwort</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.Password && touched.Password} type={passwordShown ? "text" : "password"} placeholder="" name="Password" value={values.Password} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Password}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="Passwordrepeat" autoComplete="off">
                                    <Form.Label column className="required" sm={6}>Passwort wiederholen</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.Passwordrepeat && touched.Passwordrepeat} type={passwordShown ? "text" : "password"} placeholder="" name="Passwordrepeat" value={values.Passwordrepeat} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Passwordrepeat}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Separator text="Gutschein-Code" />
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="Coupon">
                                    <Form.Label column sm={6}>Gutschein-Code</Form.Label>
                                    <Col sm={6}>
                                        <InputGroup>
                                            <Form.Control isInvalid={couponStatus == "error"} placeholder="" name="Coupon" value={couponCode} onChange={e => setCouponCode(e.target.value)} onBlur={couponChanged} aria-label="Gutschein-Code" />
                                            <InputGroup.Text>
                                                {couponStatus == "waiting" && <i className="fas fa-fw fa-percent"></i>}
                                                {couponStatus == "loading" && <i class="fas fa-fw fa-spinner fa-spin-pulse"></i>}
                                                {couponStatus == "error" && <i class="fas fa-fw fa-exclamation text-danger"></i>}
                                                {couponStatus == "success" && <i class="fas fa-fw fa-check text-success"></i>}
                                            </InputGroup.Text>
                                        </InputGroup>
                                    </Col>
                                </Form.Group>
                                {couponStatus == "error" && (
                                    <div className="text-danger">Der eingegebene Gutscheincode ist ungültig.</div>
                                )}
                                {couponStatus == "success" && (
                                    <div className="text-success">Gutscheincode erfolgreich aktiviert.</div>
                                )}
                            </Col>
                        </Row>

                        <Row className="mt-4">
                            <Col xs={12} lg={6}>
                                <MandatoryFieldNotice/>
                            </Col>
                            <Col xs={12} className="text-right">
                                <Button variant="secondary" type="submit">
                                   Fortfahren
                                </Button>
                            </Col>
                        </Row>


                        

                    </Form>
                )}
            </Formik >
        );
    }

    // paketauswahl

    if (step == 1) {
        return (
            <>
                <Separator text="Paketauswahl" />
                <p>Bitte wählen Sie Ihr gewünschtes Paket aus.</p>
                <p>Entspricht keins der oberen Pakete Ihren Ansprüchen? Dann kontaktieren Sie uns gerne per E-Mail.</p>
                <Alert type="info">
                    <strong>Aktion:</strong> Beim Buchen eines beliebigen Abonnements erhalten Sie 3 Monate Laufzeit und 3 Termine gratis dazu.
                </Alert>                
                <Table>
                    <thead>
                        <tr>
                            <th className="level-0 border-top-0">Pakete</th>
                            {abos.map(i => <th key={i.AboID} className="level-1 text-center border-top-0">{i.Name}</th>)}
                        </tr>
                    </thead>
                    <tbody>

                        <tr>
                            <td className="level-0">Laufzeit</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{i.Period} Monate</td>)}
                        </tr>
                        <tr>
                            <td className="level-0">Mögliche Termine pro Monat</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{i.Contingent/i.Period}</td>)}
                        </tr>
                        <tr>
                            <td className="level-0">Anzahl Benutzer</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{i.User}</td>)}
                        </tr>
                        <tr>
                            <td className="level-0">Anzahl Referenten</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{i.Contactperson > 999 ? "Unbegrenzt" : i.Contactperson}</td>)}
                        </tr>
                        <tr>
                            <td className="level-0">Umkreis (PLZ Standort)</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{i.Radius > 300 ? "deutschlandweit" : i.Radius + " km"}</td>)}
                        </tr>
                        <tr>
                            <td className="level-0">Support (Hotline/Email)</td>
                            <td className="level-1 text-center">Inklusive</td>
                            <td className="level-2 text-center">Inklusive</td>
                            <td className="level-3 text-center">Inklusive</td>
                            <td className="level-4 text-center">Inklusive</td>
                            <td className="level-5 text-center">Inklusive</td>
                        </tr>
                        <tr>
                            <td className="level-0">Preis pro Monat (exkl. MwSt)</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{i.Price + " €"}</td>)}
                        </tr>
                        <tr className="book">
                            <td className="level-0"></td>
                            <td className="level-1 text-center"><button className="btn btn-secondary" onClick={() => setAbo(1)}>Auswählen</button></td>
                            <td className="level-2 text-center"><button className="btn btn-secondary" onClick={() => setAbo(2)}>Auswählen</button></td>
                            <td className="level-3 text-center"><button className="btn btn-secondary" onClick={() => setAbo(3)}>Auswählen</button></td>
                            <td className="level-4 text-center"><button className="btn btn-secondary" onClick={() => setAbo(4)}>Auswählen</button></td>
                            <td className="level-5 text-center"><button className="btn btn-secondary" onClick={() => setAbo(5)}>Auswählen</button></td>
                        </tr>
                    </tbody>
                </Table>

                <div>
                    <Button type="button" variant="primary" onClick={() => back()}><i className="fa-solid fa-chevron-left mr-2"></i>Zurück</Button>
                </div>
            </>
        );
    }

    // abschluss

    if (step == 2) {
        const selectedAbo = abos.find(m => m.AboID == data.abo);
        if (!selectedAbo) selectedAbo = {};

        return (
            <Formik
                innerRef={(f) => formRef2.current = f}
                validationSchema={schema2}
                validateOnChange={true}
                validateOnBlur={true}
                onSubmit={(values) => {
                    handleSubmitBusiness(values);
                }}
                initialValues={{
                    NewsletterOptIn: true,
                    ConditionOfUse: data.ConditionOfUse
                }}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                }) => {

                    return (
                        <Form noValidate onSubmit={handleSubmit} className="mt-3">
                            <Separator text="Zusammenfassung" />
                            <Alert type="info">
                                <strong>Aktion:</strong> Beim Buchen eines beliebigen Abonnements erhalten Sie 3 Monate Laufzeit und 3 Termine gratis dazu.
                            </Alert> 
                            <Row className="mb-3">
                                <Col xs={12} lg={6}>
                                    <Card className="mb-3">
                                        <Card.Header>Unternehmensdaten</Card.Header>
                                        <Card.Body className="py-2">
                                            <Table size="sm" className="mb-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="border-top-0">Unternehmensbezeichnung</td>
                                                        <td className="text-right border-top-0">{data.OrganisationName}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Betriebskategorie</td>
                                                        <td className="text-right">{data.Category.map(i => i.label).join(", ")}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Straße + Hausnummer</td>
                                                        <td className="text-right">{data.Street} {data.HouseNo}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Adresszusatz</td>
                                                        <td className="text-right">{data.AdditionToAddress}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Postleitzahl + Stadt</td>
                                                        <td className="text-right">{data.PostCode} {data.City}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Unternehmenstyp</td>
                                                        <td className="text-right">
                                                            {data.Radio == 1 && <span>Handelsregisternummer & Amtsgericht</span>}
                                                            {data.Radio == 2 && <span>Kammerzugehörigkeit</span>}
                                                            {data.Radio == 3 && <span>Gewerbeschein</span>}
                                                            {data.Radio == 4 && <span>Instituion des öffentlichen Rechts</span>}
                                                        </td>
                                                    </tr>
                                                    {data.Radio == 1 && (
                                                        <>
                                                            <tr>
                                                                <td>Handelsregisternummer</td>
                                                                <td className="text-right">{data.CompRegNo}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Amtsgericht</td>
                                                                <td className="text-right">{data.Court}</td>
                                                            </tr>
                                                        </>
                                                    )}
                                                    {data.Radio == 2 && (
                                                        <tr>
                                                            <td>Kammerzugehörigkeit</td>
                                                            <td className="text-right">{data.ChamberMembership}</td>
                                                        </tr>
                                                    )}
                                                    {data.Radio == 3 && (
                                                        <tr>
                                                            <td>Gewerbeschein</td>
                                                            <td className="text-right">Hochgeladen</td>
                                                        </tr>
                                                    )}

                                                </tbody>
                                            </Table>
                                        </Card.Body>
                                    </Card>

                                    <Card>
                                        <Card.Header>Ausgewähltes Paket</Card.Header>
                                        <Card.Body className="py-2">
                                            <Table size="sm" className="mb-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="border-top-0">Paketname</td>
                                                        <td className="text-right border-top-0">
                                                            {selectedAbo.Name}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Termine pro Monat</td>
                                                        <td className="text-right">
                                                            {selectedAbo.Contingent/selectedAbo.Period}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Paketlaufzeit</td>
                                                        <td className="text-right">
                                                            {selectedAbo.Period} Monate
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Preis pro Monat (exkl. MwSt)</td>
                                                        <td className="text-right">
                                                            {selectedAbo.Price} €
                                                        </td>
                                                    </tr>
                                                    {activeCoupon && (
                                                        <>
                                                            <tr>
                                                                <td>Aktivierter Gutscheincode</td>
                                                                <td className="text-right">
                                                                    {activeCoupon}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>Reduzierter Preis pro Monat (exkl. MwSt)</td>
                                                                <td className="text-right">
                                                                    {selectedAbo.Price - selectedAbo.Price * (reduction / 100)} €
                                                                </td>
                                                            </tr>
                                                        </>
                                                    ) }
                                                </tbody>
                                            </Table>
                                        </Card.Body>
                                    </Card>

                                </Col>
                                <Col xs={12} lg={6}>
                                    <Card className="mb-3">
                                        <Card.Header>Benutzerdaten</Card.Header>
                                        <Card.Body className="py-2">
                                            <Table size="sm" className="mb-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="border-top-0">Anrede</td>
                                                        <td className="text-right border-top-0">{getSalutation(data.SalutationID)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Titel</td>
                                                        <td className="text-right">{data.Title}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Vorname</td>
                                                        <td className="text-right">{data.FirstName}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Nachname</td>
                                                        <td className="text-right">{data.LastName}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Telefonnnummer</td>
                                                        <td className="text-right">{data.PhoneNo}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>E-Mail-Adresse</td>
                                                        <td className="text-right">{data.Email}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Benutzername</td>
                                                        <td className="text-right">{data.Username}</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Card.Body>
                                    </Card>

                                    {data.IsAlternativeBilling && (
                                        <Card>
                                            <Card.Header>Abweichende Rechnungsadresse</Card.Header>
                                            <Card.Body className="py-2">
                                                <Table size="sm" className="mb-0">
                                                    <tbody>
                                                        <tr>
                                                            <td className="border-top-0">E-Mail-Adresse</td>
                                                            <td className="text-right border-top-0">{data.BillingEmail}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Straße + Hausnummer</td>
                                                            <td className="text-right">{data.BillingStreet} {data.BillingHouseNo}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Adresszusatz</td>
                                                            <td className="text-right">{data.BillingAdditionToAddress}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Postleitzahl + Stadt</td>
                                                            <td className="text-right">{data.BillingPostCode} {data.BillingCity}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </Card.Body>
                                        </Card>
                                    )}

                                </Col>
                            </Row>

                            <Row>
                                {/*<Col xs={12}>*/}
                                {/*    <Form.Group className="mb-3" controlId="NewsletterOptIn">*/}
                                {/*        <Form.Check type="checkbox" name="NewsletterOptIn" label="Ich möchte wöchentlich über Termine per Mail informiert werden." value={values.NewsletterOptIn} onChange={handleChange} isInvalid={errors.NewsletterOptIn} />*/}
                                {/*        <Form.Control.Feedback type="invalid">*/}
                                {/*            {errors.NewsletterOptIn}*/}
                                {/*        </Form.Control.Feedback>*/}
                                {/*    </Form.Group>*/}
                                {/*</Col>*/}
                                <Col xs={12}>
                                    <Form.Group className="mb-3" controlId="ConditionOfUse">
                                        <Form.Check className="required" type="checkbox" name="ConditionOfUse" label={<span>Ich akzeptiere die <a target="_blank" href="/nutzungsbedingungen"><u>Nutzungsbedingungen</u>.</a></span>} value={values.ConditionOfUse} onChange={handleChange} isInvalid={errors.ConditionOfUse} />
                                        {errors.ConditionOfUse && (
                                            <div className="text-danger">{errors.ConditionOfUse}</div>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col xs={12}>
                                    Bitte nehmen Sie auch unsere <a target="_blank" href="/datenschutz"><u>Datenschutzerklärung</u></a> zur Kenntnis.
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Button type="button" variant="primary" onClick={() => back()}><i className="fa-solid fa-chevron-left mr-2"></i>Zurück</Button>
                                </Col>
                                <Col xs={6} className="text-right">
                                    <Button type="submit" variant="secondary"><i className="fa-solid fa-right-to-bracket mr-2"></i>Registrierung abschließen</Button>
                                </Col>
                            </Row>

                            <MandatoryFieldNotice />
                        </Form>
                    )
                }}
            </Formik>
        );
    }

}

export default Register;